/**
 * Copy of the counter price readers (cross-module X XWP-80, XD-228): the price a counter line is
 * charged, read from the one sale-price resolver (lib/prix-vente.js). French UI strings only — no
 * rule lives here.
 */

export const PRIX_VENTE_COPIE = Object.freeze({
  /** a line / row the resolver cannot price (no lot > 0, no Produit.ppa > 0) — never shown as 0 DA */
  inconnu: "Prix inconnu",
  /** `Produit.ppa` as secondary text when the line is charged at another price (an AMLOR-like lot) */
  ppaProduit: (montant) => `PPA produit ${montant}`,
  /** validation refused at the counter while a line has no price */
  lignesSansPrix: (noms) =>
    `Prix de vente inconnu pour ${noms.map((n) => `« ${n} »`).join(", ")} — retirez la ligne ou demandez au propriétaire de renseigner son prix.`,
});
